import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import * as AttributesActions from '../actions/attributes.actions';
import {Attribute} from '../models/attribute';
import {createReducer, on} from '@ngrx/store';

export enum AttributesInitializationState {
    NEW,
    PENDING,
    FINISHED,
    ERROR
}

export interface AttributesState extends EntityState<Attribute> {
    initializationState: AttributesInitializationState;
}

export const adapter: EntityAdapter<Attribute> = createEntityAdapter<Attribute>({
    selectId: (attribute: Attribute) => attribute.code,
    sortComparer: false
});

export const initialState: AttributesState = adapter.getInitialState({
    initializationState: AttributesInitializationState.NEW
});

export const reducer = createReducer(
    initialState,
    on(AttributesActions.loadAttributes, state => ({...state, initializationState: AttributesInitializationState.PENDING})),
    on(AttributesActions.loadAttributesSuccess, (state, action) => {
        return adapter.addMany(action.attributes, {...state, initializationState: AttributesInitializationState.FINISHED});
    }),
    on(AttributesActions.loadAttributesFailure, (state) => ({...state, initializationState: AttributesInitializationState.ERROR})),
);

export const getInitializationState = (state: AttributesState) => state.initializationState;
